import React from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {RadioButtonGroup} from 'common/styleguide/RadioGroup'
import {OrderedMap} from 'immutable'
import flagUS from './us-icon.svg'
import flagUK from './uk-icon.svg'
import flagES from './spain-icon.svg'
import flagFR from './france-icon.svg'
import flagDE from './germany-icon.svg'
import flagNL from './ned-icon.svg'
import flagJP from './japan-icon.svg'
import styles from './ChangeLocaleModal.scss'
import {localeSelectors, localeActions} from 'data/reducers/locale'
import {connect} from 'react-redux'
import {FormattedMessage} from 'react-intl'
import {userIsAdmin} from 'lib/utils'
import moment from 'moment'

export const CHANGE_LOCALE_MODAL = 'CHANGE_LOCALE_MODAL'

const FlagButton = ({flag, children, tip}) => (
  <span className={styles.FlagButton} data-tip={!!tip} title={tip}>
    <span>{children}</span>
    <img src={flag} />
  </span>
)

const MDY = moment().format('M/D/YY')
const DMY = moment().format('D/M/YY')

const locales1 = OrderedMap({
  'en-US': <FlagButton flag={flagUS} tip={`1.2 mi, ${MDY}`}>English (mi)</FlagButton>,
  'es': <FlagButton flag={flagES} tip={`1.9 km, ${DMY}`}>Español</FlagButton>,
  'fr': <FlagButton flag={flagFR} tip={`1.9 km, ${DMY}`}>Français</FlagButton>,
  'ja': <FlagButton flag={flagJP} tip={`1.9 km, ${DMY}`}>日本語</FlagButton>
})

const _locales2 = OrderedMap({
  'en-UK': <FlagButton flag={flagUK} tip={`1.9 km, ${DMY}`}>English (km)</FlagButton>,
  'de': <FlagButton flag={flagDE} tip={`1.9 km, ${DMY}`}>Deutsche</FlagButton>,
  'nl': <FlagButton flag={flagNL} tip={`1.9 km, ${DMY}`}>Nederlands</FlagButton>
})

const locales2 = userIsAdmin
  ? _locales2.set('mz', <FlagButton flag={flagUS}>Marklar (admin)</FlagButton>)
  : _locales2

class _ChangeLocaleModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      locale: props.locale
    }
  }

  setLocaleAndClose = () => {
    const {setLocale, onRequestClose} = this.props
    setLocale(this.state.locale)
    onRequestClose()
  }

  render () {
    const {onRequestClose} = this.props
    const {locale} = this.state
    return (
      <ConfirmationDialog
        showCloseButton
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.setLocaleAndClose}
        maxWidth='600px'
        title={<FormattedMessage id='ChangeLocaleModal.title' defaultMessage='Change Language/Region' />}>
        <div className={styles.twoCol}>
          <RadioButtonGroup
            name='localeselect1'
            options={locales1}
            onChange={locale => this.setState({locale})}
            selected={locale} />
          <RadioButtonGroup
            name='localeselect2'
            options={locales2}
            onChange={locale => this.setState({locale})}
            selected={locale} />
        </div>
      </ConfirmationDialog>
    )
  }
}

const mapStateToProps = state => ({
  locale: localeSelectors.locale(state)
})

const mapDispatchToProps = {
  setLocale: localeActions.setLocale
}

export const ChangeLocaleModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(_ChangeLocaleModal)
